import React, { useState, useEffect } from 'react';
import axios from "axios";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Button from 'react-bootstrap/Button';
import ModalDetalleTraspaso from './ModalDetalleTraspaso';

export default function TablaTraspasos() {
    const obtenerTraspasosURL = "https://invio.datachile.site/Web/Sonoco/ObtenerTraspasos.php";
    const obtenerDetallesTraspasoURL = "https://invio.datachile.site/Web/Sonoco/ObtenerTraspasosDetalle.php";

    const [traspasos, setTraspasos] = useState([]);
    const [traspasoSeleccionado, setTraspasoSeleccionado] = useState(null);
    const [detalles, setDetalles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [empresaId, setEmpresaId] = useState(null);

    useEffect(() => {
        const usuario = JSON.parse(localStorage.getItem('usuario'));
        if (usuario && usuario.empresa_idEmpresa) {
            setEmpresaId(usuario.empresa_idEmpresa);
            getTraspasos(usuario.empresa_idEmpresa);
        }
    }, []);

    const getTraspasos = async (empresa_idEmpresa) => {
        try {
            const response = await axios.post(obtenerTraspasosURL, { empresa_idEmpresa });
            setTraspasos(response.data);
        } catch (error) {
            console.error('Error al obtener traspasos:', error);
        }
    };

    const handleShowModal = async (idTraspaso) => {
        try {
            const response = await axios.post(obtenerDetallesTraspasoURL, { idTraspaso, empresa_idEmpresa: empresaId });
            setDetalles(response.data);
            const traspaso = traspasos.find(t => t.idTraspaso === idTraspaso);
            setTraspasoSeleccionado(traspaso);
            setShowModal(true);
        } catch (error) {
            console.error('Error al obtener detalles del traspaso:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setTraspasoSeleccionado(null);
        setDetalles([]);
    };

    return (
        <Container>
            <h2 className="my-4 text-center" style={{ fontWeight: 'bold', color: '#007bff' }}>Gestión de Traspasos</h2>
            <div className="table-responsive">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th># Traspaso</th>
                            <th>Usuario</th>
                            <th>Fecha</th>
                            <th>Origen</th>
                            <th>Destino</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {traspasos.length > 0 ? (
                            traspasos.map((traspaso) => (
                                <tr key={traspaso.idTraspaso}>
                                    <td className='centrar'>{traspaso.idTraspaso}</td>
                                    <td className='centrar'>{traspaso.usuario}</td>
                                    <td className='centrar'>{traspaso.fecha_envio}</td>
                                    <td className='centrar'>{traspaso.origen}</td>
                                    <td className='centrar'>{traspaso.destino}</td>
                                    <td>
                                        <Button variant="primary" size="sm" onClick={() => handleShowModal(traspaso.idTraspaso)}>
                                            Ver Detalles
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">No hay traspasos disponibles</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* Modal separado en otro archivo */}
            <ModalDetalleTraspaso
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                traspasoSeleccionado={traspasoSeleccionado}
                detalles={detalles}
            />
        </Container>
    );
}
